import { Plus } from 'lucide-react'
import { cn } from '@/lib/cn'

export interface EmptyCellProps {
  onAssign: () => void
  variant?: 'default' | 'monthly'
  className?: string
  /** Whether the viewer may add shifts; the grid checks it once for every cell. */
  canCreate: boolean
}

export function EmptyCell({
  onAssign,
  variant = 'default',
  className,
  canCreate,
}: EmptyCellProps): React.ReactElement | null {
  if (variant === 'monthly') {
    return (
      <div
        className={cn(
          'group flex min-h-[40px] w-full items-center justify-center rounded border border-dashed border-gray-200 dark:border-gray-700',
          className
        )}
      >
        {canCreate && (
          <button
            type="button"
            onClick={onAssign}
            className="flex h-full min-h-[40px] w-full cursor-pointer items-center justify-center text-gray-400 opacity-0 transition-opacity focus:opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-inset group-hover:opacity-100 dark:text-gray-500"
            aria-label="Assign shift for this day"
          >
            <Plus className="h-4 w-4" />
          </button>
        )}
      </div>
    )
  }

  if (!canCreate) return null

  return (
    <button
      type="button"
      onClick={onAssign}
      className={cn(
        'flex h-full min-h-[44px] w-full cursor-pointer flex-row items-center justify-center gap-1 rounded-md border border-dashed border-gray-200 text-gray-400 transition-colors hover:border-primary/30 hover:bg-primary/5 hover:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/60 focus-visible:ring-offset-1 dark:border-gray-700 dark:text-gray-500 dark:hover:border-primary-light dark:hover:bg-primary-light/10',
        className
      )}
      aria-label="Assign shift for this day"
    >
      <Plus className="h-3.5 w-3.5" />
      <span className="text-xs">Add shift</span>
    </button>
  )
}

EmptyCell.displayName = 'EmptyCell'
